import { render, staticRenderFns } from "./TemplateFieldsEntityReationshipWidget.vue?vue&type=template&id=8fe9343e&scoped=true"
import script from "./TemplateFieldsEntityReationshipWidget.vue?vue&type=script&lang=js"
export * from "./TemplateFieldsEntityReationshipWidget.vue?vue&type=script&lang=js"
import style0 from "./TemplateFieldsEntityReationshipWidget.vue?vue&type=style&index=0&id=8fe9343e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe9343e",
  null
  
)

export default component.exports